// import Vue from 'vue';
// import {VueSpinners} from '@saeris/vue-spinners'
//
// Vue.use(VueSpinners)

const readCookie = (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}


const readCookiePlugin = {
    install: (Vue) => {
        Vue.prototype.$readCookie = readCookie
    }
}

export {readCookie}
export default readCookiePlugin
